import { useMutation, UseMutationOptions } from 'react-query'

import { CSRF } from '../utils/CSRF'
import { projectRepository } from '.'
import { BaseRepository } from './BaseRepository'

export type Project = {
  id: number
  uuid: string
  name: string
  user_id: number
  description: string
  url: string
  created_at: string
  updated_at: string
}
export class ProjectRepository extends BaseRepository {
  getAllProjects = async () => {
    return (
      await super.getHttpClientInstance().get<Project[]>('/projects', {
        'X-CSRF-Token': CSRF.getToken(),
        Accept: 'application/json',
      })
    ).data
  }

  createProject(args: CreateProjectArgs) {
    return super.getHttpClientInstance().post(
      '/projects',
      {
        ...args,
      },
      {
        'X-CSRF-Token': CSRF.getToken(),
        Accept: 'application/json',
      },
    )
  }
  updateProjectTimeStamp(args: UpdateProjectTimeStampArgs) {
    return super.getHttpClientInstance().patch(
      `/projects/${args.uuid}/touch`,
      {},
      {
        'X-CSRF-Token': CSRF.getToken(),
        Accept: 'application/json',
      },
    )
  }
}

type UpdateProjectTimeStampArgs = {
  uuid: string
}

type CreateProjectArgs = {
  name: string
  description: string
  public: boolean
  collaboration: boolean
}

type CreateProjectResult = {
  archive: boolean
  clips_count: number
  collaboration: boolean
  created_at: string
  description: string
  id: number
  name: string
  public: boolean
  team_id: number
  updated_at: string
  user_id: number
  uuid: string
}

type MutationOptions = Omit<UseMutationOptions<CreateProjectResult, unknown, CreateProjectArgs>, 'mutationFn'> | undefined
export const useCreateNewProjectMutation = (options?: MutationOptions) =>
  useMutation(
    async (args: CreateProjectArgs) => {
      const response = await projectRepository.createProject(args)
      return response.data
    },
    {
      ...options,
    },
  )

type UpdateProjectTimestampMutationOptions = Omit<UseMutationOptions<unknown, unknown, UpdateProjectTimeStampArgs>, 'mutationFn'> | undefined
export const useUpdateProjectTimestampMutation = (options?: UpdateProjectTimestampMutationOptions) =>
  useMutation(
    async (args: UpdateProjectTimeStampArgs) => {
      const response = await projectRepository.updateProjectTimeStamp(args)
      return response.data
    },
    {
      ...options,
    },
  )
